module.exports = __webpack_public_path__ + "img/svg/icon-matches.20a83f876a45a28c257610f407ad8121.svg";